import React from 'react'

function Home() {
  return (
    <div style={{width:"100%",height:"100%",backgroundImage:'url("./nes.png")'}}>
        <img src={require("./gk.png")} style={{width:"100%",height:window.innerHeight-65}}/>
       
    </div>
  )
}

export default Home